module.exports = __webpack_public_path__ + "static/scene-digital-4-e06b8f1ee906b40278ad2f9d9df17762.png";